import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const LeaderboardPrize = () => {
  const [f, setF] = useState({ prize: "", note: "" });
  const [month, setMonth] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/leaderboard").then((r) => { setF({ prize: r.data.prize || "", note: r.data.note || "" }); setMonth(r.data.month); }).catch(() => {}); }, []);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await api.put("/settings/leaderboard", f); setF({ prize: r.data.prize || "", note: r.data.note || "" }); toast.success(r.data.prize ? "Prize is live on the leaderboard" : "Prize removed"); } catch (ex) { toast.error(errMsg(ex)); }
    setBusy(false);
  };
  return (
    <div className="panel" data-testid="leaderboard-prize-settings">
      <h3><Gift size={15} style={{ verticalAlign: -2, marginRight: 6 }} />Leaderboard prize · {month}</h3>
      <p className="ss" style={{ marginTop: 4 }}>Shown at the top of the client streak leaderboard. The client with the longest streak at the end of the month wins it.</p>
      <form onSubmit={save} className="frow" style={{ alignItems: "flex-end", flexWrap: "wrap", gap: 12, marginTop: 12 }}>
        <div style={{ flex: "1 1 220px" }}><label>Prize</label><input value={f.prize} maxLength={120} onChange={(e) => setF({ ...f, prize: e.target.value })} placeholder="Free PT session · $50 gift card · studio hoodie" data-testid="prize-input" /></div>
        <div style={{ flex: "2 1 260px" }}><label>Note (optional)</label><input value={f.note} maxLength={200} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Winner announced on the 1st in the group chat" data-testid="prize-note-input" /></div>
        <button className="btn" disabled={busy} data-testid="prize-save">Save prize</button>
      </form>
    </div>
  );
};
